import {env} from '../../../environment'

const fetchVersion = (options: any) => {
  const url = env.getServiceHost() + 'products/version'
  return fetch(url).then(response => response.json())
}

export default fetchVersion
